import React from 'react';
import Paper from '@material-ui/core/Paper';
import urlBase from '../../../url-base';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from 'material-ui/Dialog';
import axios from 'axios';
import PropTypes from 'prop-types';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Grid from '@material-ui/core/Grid';
import TextField from 'material-ui/TextField';
import InputMask from 'react-input-mask';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';


class BackOfficeList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      brokerId : '',
      name: '',
      email: '',
      password: '',
      image: '',
      phone: '',

      emailError: {
        display: 'none',
        msg: ''
      },

      data: 'loading',
      modalOpen: false,
      success: null,
      loadingSave: false,

      confirmDelete: false,
      disabledActionsDelete: false,
      backOfficeToDelete: '',

      showTable: false
    };

    this.styles = {
      error: {
        textAlign: 'center',
        fontSize: 18,
        color:'#ea0000',
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      zero: {
        textAlign: 'center',
        fontSize: 18,
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      modal: {
        width: '85%',
        maxWidth: 'none',
      },
      closeBtn: {
        float: 'right',
        width: 25,
        cursor: 'pointer',
        position: 'relative',
        bottom: 15,
        left: 5,
      },
      sendFormSuccess: {
        padding: 10,
        color: '#155724',
        backgroundColor: '#d4edda',
        borderColor: '#c3e6cb'
      },
      sendFormError: {
        padding: 10,
        color: '#721c24',
        backgroundColor: '#f8d7da',
        borderColor: '#f5c6cb'
      },
      iconDelete: {
        fontSize: '1.5em',
        cursor: 'pointer'
      }
    };

    // Campos obrigatórios
    this.errorField = {
      name: '',
      email: '',
      password: ''
    };

    this.errorFormat = {
      email: ''
    };
  }


  componentWillMount() {
    this.getData();
  }

  getData() {
    let url = urlBase.loopBack + 'Brokers?filter={"where":{"userId":"'+localStorage.getItem('dental_u')+'"}}';

    axios.get(url)
    .then((response) => {
      let state = this.state;
      state.brokerId = response.data[0].id;
      this.setState(state);

      url = urlBase.loopBack + 'Accounts?filter={"where":{"and":[{"type":"BACKOFFICE"},{"brokerId":"'+
            response.data[0].id+'"}]}}&access_token='+localStorage.getItem('dental_t');

      axios.get(url)
      .then((response2) => {
        let state = this.state;
        state.data = response2.data;
        if (state.showTable == false) {
          state.showTable = true;

          $(document).ready( function () {
            $('#table_id').DataTable({
              "language": {
                "url": urlBase.client + "assets/plugins/datatables/Portuguese-Brasil.lang"
              },
              "order": [[0, "desc"]],
              lengthMenu: [
                [10, 25, 50, 100, -1],
                ['10', '25', '50', 100, 'Todas']
              ],
              columnDefs: [
                { 'targets': 2, 'orderable': false, 'searchable':false },
              ],
            });
          });
        }

        this.setState(state);
      })
      .catch(function () {
        let state = this.state;
        state.data = 'error';
        this.setState(state);
      }.bind(this));

    })
    .catch(function () {
      let state = this.state;
      state.data = 'error';
      this.setState(state);
    }.bind(this));
  }

  addBackOffice() {
    let state = this.state;
    state.modalOpen = true;
    state.success = null;
    this.setState(state);
  }
  
  handleModalClose() {
    this.setState({modalOpen: false});
    this.getData();
  }

  fileToBase64() {
    let reader = new FileReader();
    let file = document.getElementById('file_image').files[0];

    reader.onloadend = function() {
      document.getElementById('image_64').value = reader.result;
    }.bind(this);
    reader.readAsDataURL(file);
  }

  saveBackOffice() {
    if (this.errorField.name.length == 0 &&
      this.errorField.email.length == 0 &&
      this.errorField.password.length == 0 &&
      this.errorFormat.email.length == 0 &&
      this.state.emailError.msg.length == 0) {
    
      let state = this.state;
      state.loadingSave = true;
      this.setState(state);

      let dataPost = {
        brokerId: this.state.brokerId,
        name: this.state.name,
        email: this.state.email,
        password: this.state.password,
        phone: this.state.phone,
        image: document.getElementById('image_64').value,
      };
      let url = urlBase.loopBack + '/Accounts/saveUserBackOffice?access_token='+localStorage.getItem('dental_t');
      
      axios.post(url, dataPost)
      .then(() => {
        let state = this.state;
        state.loadingSave = false;
        state.success = true;
        this.setState(state);
        this.stateDefault();
      })
      .catch(function () {
        let state = this.state;
        this.errorField.cpf = 'Erro ao salvar BackOffice.';
        state.validCpf = false;
        state.loadingCpf = false;
        state.success = false;
        this.setState(state);
      }.bind(this));
    }
    else
      alert('Necessário preencher os campos de forma correta.');
  }

  stateDefault() {
    let state = this.state;
    state.name = '',
    state.email = '',
    state.password = '',
    state.image = '',
    state.phone = '',
    state.loadingSave = false,
    state.emailError = {
      display: 'none',
      msg: ''
    };

    this.setState(state);
  }

  // Monitora mudanças a atualiza estados dos inputs text
  onChange(e) {
    let state = this.state;
    state[e.target.name] = e.target.value;

    if (e.target.value == '')
      this.errorField[e.target.name] = 'Campo obrigatório';
    else
      this.errorField[e.target.name] = '';

    this.setState(state);
  }

  onBlurField(e) {
    let state = this.state;
    state.emailError.display = 'none';
    state.emailError.msg = '';
    this.setState(state);

    if (e.target.type == 'email') {
      if (!e.target.validity.valid)
        this.errorFormat[e.target.name] = 'Formato esperado: email@exemplo.com';
      else {
        this.onBlurEmail(e);
        this.errorFormat[e.target.name] = '';
      }
    }
  }

  confirmDeleteOpen(backOfficeId) {
    let state = this.state;
    state.backOfficeToDelete = backOfficeId;
    state.confirmDelete = true;
    this.setState(state);
  }

  confirmDeleteClose() {
    this.setState({confirmDelete: false});
  }

  deleteBackOffice() {
    // Caso tenha um usuário a ser deletado
    if (this.state.backOfficeToDelete.length > 0){
      let url = urlBase.loopBack + 'Accounts/'+this.state.backOfficeToDelete+'?access_token='+localStorage.getItem('dental_t');

      axios.delete(url)
      .then(() => {
        let state = this.state;
        state.backOfficeToDelete = '';
        state.confirmDelete = false;
        this.setState(state);
        this.getData();
      })
      .catch(function () {
        alert('Erro ao deletar BackOffice');
      });
    }
  }


  render() {
    const actions = [
      <FlatButton
        key={0}
        label="Não"
        primary={true}
        disabled={this.state.disabledActionsDelete}
        onTouchTap={this.confirmDeleteClose.bind(this)}
      />,
      <FlatButton
        key={1}
        label="Sim"
        primary={true}
        disabled={this.state.disabledActionsDelete}
        onTouchTap={this.deleteBackOffice.bind(this)}
      />,
    ];

    return (
      <div>
        
        {/* ############# CSS PARA DATATABLE ############# */}
        <link
          rel="stylesheet" type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css"
        />
        <link
          rel="stylesheet" type="text/css"
          href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css"
        />
        {/* ############# CSS PARA DATATABLE ############# */}

        {
          this.state.data == 'loading' ? (
        <div style={{textAlign: 'center'}}>
          <CircularProgress />
          <p>Carregando...</p>
        </div>
          ) : (
            this.state.data == 'error' ? (
        <p style={this.styles.error}>
          Erro ao buscar dados.
        </p>
            ) : (
              this.state.data == 'zero' ? (
        <div style={this.styles.zero}>
          <p>Nenhuma proposta encontrada.</p>
        </div>
              ) : (
        <div>
          <Paper style={{overflow: 'auto', boxShadow:"none", marginLeft: 10, borderRadius:0}}>
            <table id="table_id" className="mdl-data-table table-striped"  style={{width:'100%'}}>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
              {this.state.data.map((item, index) =>
                <tr
                  key={index}
                  className="row_table"
                  //onClick={this.details.bind(this, item.salesId)}
                  //style={{cursor:'pointer'}}
                >
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td style={{textAlign: 'center'}}>
                    <i
                      style={this.styles.iconDelete}
                      className="far fa-trash-alt fa-2x"
                      onClick={this.confirmDeleteOpen.bind(this, item.id)}
                    >
                      {''}
                    </i> 
                  </td>
                </tr>
              )}
              </tbody>
            </table>
          </Paper>

          <div style={{float: 'right', marginTop:10}}>
            <FloatingActionButton
              onClick={this.addBackOffice.bind(this)}
            >
              <ContentAdd />
            </FloatingActionButton>
          </div>

          <style>{`
            #table_id_wrapper {
              width:100%;
            }
            #table_id_wrapper > :first-child {
              width: 100%;
            }
            #table_id_wrapper > :last-child {
              width: 100%;
            }

            .dt-table {
              width:100%;
              padding: 0;
            }
            .dt-table .mdl-cell {
              margin: 0;
              width:100%;
            }
            #table_id_length select {
              padding: .375rem .75rem;
              font-size: 1rem;
              line-height: 1.5;
              color: #495057;
              background-color: #fff;
              background-clip: padding-box;
              border: 1px solid #ced4da;
              border-radius: .25rem;
              transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
            }
            #table_id_filter input {
              padding: .375rem .75rem;
              font-size: 1rem;
              line-height: 1.5;
              color: #495057;
              background-color: #fff;
              background-clip: padding-box;
              border: 1px solid #ced4da;
              border-radius: .25rem;
              transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
            }
            thead {
              background-color: #f5aa00;
            }
            th {
              text-align: center !important;
              color: #fff !important;
              font-size: 14px !important;
              font-weight: 500 !important;
              white-space: normal !important;
            }
            td {
              font-size: 12px;
              font-family: "RubikRegular";
              border-bottom: 1px solid #ccc;
              text-align: center !important;
            }
            table.dataTable thead .sorting:before,
            table.dataTable thead .sorting_asc:before,
            table.dataTable thead .sorting_desc:before,
            table.dataTable thead .sorting_asc_disabled:before,
            table.dataTable thead .sorting_desc_disabled:before {
              font-size: 15px;
              content: "▲";
            }
            table.dataTable thead .sorting:after,
            table.dataTable thead .sorting_asc:after,
            table.dataTable thead .sorting_desc:after,
            table.dataTable thead .sorting_asc_disabled:after,
            table.dataTable thead .sorting_desc_disabled:after {
              font-size: 15px;
              content: "▼";
            }
            .pagination {
              text-align: right !important;
              display: inline-block;
            }
            .pagination button {
              padding: 0 5px;
              font-size: 13px;
              height: 32px;
              min-width: 32px;
            }
            .mdl-grid{
              font-family: 'RubikRegular'!important;
              color:#757575!important;
              border:none;
            }
            .mdl-data-table {
              white-space: normal;
              text-transform: uppercase;
              font-family: 'RubikRegular'!important;
              color:#757575;
              border:none;
            }
            .mdl-data-table td {
              padding: 0 0px 0px;
              border-top:none;
              border-bottom:none;
            }
            .mdl-data-table td:first-of-type,
            .mdl-data-table th:first-of-type {
              padding-left: 8px;
            }
            .mdl-data-table td:last-of-type, .mdl-data-table th:last-of-type {
              padding-right: 0;
            }
          `}</style>

          <Dialog
            title={
              <div>
                Cadastrar BackOffice
                <img
                  style={this.styles.closeBtn}
                  src={urlBase.client+'/assets/images/icons/icon_close.png'}
                  onClick={this.handleModalClose.bind(this)}
                />
              </div>
            }
            titleStyle={{textAlign:'center'}}
            bodyStyle={{padding: '0 10px 24px'}}
            actions={<span>&nbsp;</span>}
            modal={false}
            open={this.state.modalOpen}
            onRequestClose={this.handleModalClose.bind(this)}
            autoScrollBodyContent={true}
            contentStyle={this.styles.modal}
          >
            <div>
              {/* Mensagem de retorno do formulário */
                this.state.success != null ? (
                  this.state.success == true ? (/* Formulário salvo com sucesso */
                <Grid container spacing={24} style={{marginTop:30}}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <div style={{textAlign: 'center'}}>
                      <p style={this.styles.sendFormSuccess}>BackOffice salvo com sucesso</p>
                    </div>
                  </Grid>
                </Grid>
                  ) : (/* Erro ao enviar formulário */
                <Grid container spacing={24} style={{marginTop:30}}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <div style={{textAlign: 'center'}}>
                      <p style={this.styles.sendFormError}>Erro ao salvar BackOffice</p>
                    </div>
                  </Grid>
                </Grid>
                  )
                ) : ('')
              }

              {/* Loading de salvar o formulário*/
              this.state.loadingSave == true ? (
              <div id="loading_form">
                <Grid container spacing={24} style={{marginTop:30}}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <div style={{textAlign: 'center'}}>
                      <CircularProgress />
                      <p>Enviando...</p>
                    </div>
                  </Grid>
                </Grid>
              </div>
                ) : (/* Formulário*/
              <div id="form">
                <Grid container spacing={24}> 
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <TextField
                      errorText={this.errorField.name}
                      style={this.styles.inputs}
                      hintText="Nome"
                      floatingLabelText="Nome *"
                      type="text"
                      name="name"
                      value={this.state.name}
                      fullWidth={true}
                      onChange={(e) => this.onChange(e)}
                      onBlur={(e) => this.onBlurField(e)}
                    />
                  </Grid>
  
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <TextField
                      errorText={this.errorFormat.email}
                      style={this.styles.inputs}
                      hintText="E-mail"
                      floatingLabelText="E-mail *"
                      type="email"
                      name="email"
                      value={this.state.email}
                      fullWidth={true}
                      onChange={(e) => this.onChange(e)}
                      onBlur={(e) => this.onBlurField(e)}
                    />
                    <p style={{
                      paddingLeft: 10,
                      color: 'rgb(244, 67, 54)',
                      fontSize: 12,
                      margin:0,
                      display: this.state.emailError.display}}
                    >
                      {this.state.emailError.msg}
                    </p>
                  </Grid>
  
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <TextField
                      errorText={this.errorField.password}
                      style={this.styles.inputs}
                      hintText="Senha"
                      floatingLabelText="Senha *"
                      type="password"
                      name="password"
                      value={this.state.password}
                      fullWidth={true}
                      onChange={(e) => this.onChange(e)}
                    />
                  </Grid>
  
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <TextField
                      //errorText={this.errorField.phone}
                      style={this.styles.inputs}
                      hintText="Telefone"
                      floatingLabelText="Telefone"
                      type="text"
                      name="phone"
                      value={this.state.phone}
                      fullWidth={true}
                      onChange={(e) => this.onChange(e)}
                      onBlur={(e) => this.onBlurField(e)}
                    >
                      <InputMask
                        mask="(99) \9 9999-9999" maskChar=" " name="phone" value={this.state.phone}
                      />
                    </TextField>
                  </Grid>
  
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <input id="image_64" type="hidden"/>
                    <label style={{paddingLeft: 10}}>Foto:</label> 
                    <br/>
                    <input
                      id="file_image"
                      type="file"
                      name="image"
                      style={{paddingLeft: 10}}
                      onChange={this.fileToBase64.bind(this)}
                    />
                  </Grid>
                </Grid>
  
  
                <Grid container spacing={24} style={{marginTop:30}}>
                  <Grid item style={{textAlign:'center'}} xs={12} sm={6} md={6} lg={6}>
                    <RaisedButton
                      label="CANCELAR"
                      primary={false}
                      onClick={this.handleModalClose.bind(this)}
                    />
                  </Grid>
  
                  <Grid item style={{textAlign:'center'}} xs={12} sm={6} md={6} lg={6}>
                    <RaisedButton
                      label="SALVAR"
                      primary={true}
                      onClick={this.saveBackOffice.bind(this)}
                    />
                  </Grid>
                </Grid>
              </div>
                )
              /*#form*/}
            </div>            
          </Dialog>

          <Dialog
            title="Confirmação"
            actions={actions}
            modal={true}
            open={this.state.confirmDelete}
          >
            {
              this.state.modalS4Loading == true ? (
            <div style={{textAlign: 'center'}}>
              <CircularProgress />
              <p>Carregando...</p>
            </div>
              ) : ('Tem certeza que deseja excluir o BackOffice?')
            }
          </Dialog>

        </div>
              )
            )
          )
        }

      </div>
    );

  }

}

BackOfficeList.propTypes = {
  table: PropTypes.string
};

export default BackOfficeList;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/BackOffice/BackOfficeList.js
 **/